import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
const slides = [{
  word: 'Communities',
  image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=1920&q=80'
}, {
  word: 'Opportunities',
  image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=1920&q=80'
}, {
  word: 'Investments',
  image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1920&q=80'
}, {
  word: 'Southwest Florida',
  image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1920&q=80'
}];
export function HeroSlideshow() {
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  return <section className="relative min-h-screen w-full overflow-hidden bg-black" data-id="element-95" data-mp="3h4p35xis6kwz">
      {/* Crossfading imagery */}
      <AnimatePresence data-id="element-96" data-mp="pc1f6hcv4jis">
        <motion.div key={current} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 1,
        ease: 'linear'
      }} className="absolute inset-0 bg-cover bg-center" style={{
        backgroundImage: `url(${slides[current].image})`
      }} aria-hidden="true" data-id="element-97" data-mp="pckml44vzpik" />
      </AnimatePresence>
      <div className="absolute inset-0 bg-black/70" aria-hidden="true" data-id="element-98" data-mp="6mcq34vozxbc" />

      {/* Statement */}
      <div className="relative z-10 min-h-screen flex items-start pt-[50px] pb-24" data-id="element-99" data-mp="3nugir6khboca">
        <div className="max-w-7xl w-full mx-auto px-6 md:px-10" data-id="element-100" data-mp="3ssrnx3ztxao6">
          <motion.p initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="text-[#C5A55A] text-xs md:text-sm tracking-[0.35em] uppercase mb-8" data-id="element-101" data-mp="3sv44bcpxvcz4">
            Real Estate Development
          </motion.p>

          <h1 className="font-serif text-white leading-[0.95]" data-id="element-102" data-mp="1klo9zi9g7itg">
            <motion.span initial={{
            opacity: 0,
            y: 24
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: 0.06,
            ease: [0.23, 1, 0.32, 1]
          }} className="block text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight" data-id="element-103" data-mp="1knhht0vss931">
              Sinclair Develops
            </motion.span>

            {/* Rotating word — font size lives on the clip box so its height
                matches the text exactly */}
            <span className="relative block mt-3 md:mt-5 text-[2rem] sm:text-5xl md:text-6xl lg:text-7xl h-[1.35em] overflow-hidden" aria-live="polite" data-id="element-104" data-mp="1ukdp539ymp60">
              <AnimatePresence mode="wait" initial={false} data-id="element-105" data-mp="2mai76va8z042">
                <motion.span key={slides[current].word} initial={{
                opacity: 0,
                y: '40%'
              }} animate={{
                opacity: 1,
                y: '0%'
              }} exit={{
                opacity: 0,
                y: '-40%'
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} className="absolute left-0 top-0 block whitespace-nowrap leading-[1.25] italic text-[#C5A55A]" data-id="element-106" data-mp="2m8xd16ruhj6q">
                  {slides[current].word}.
                </motion.span>
              </AnimatePresence>
            </span>
          </h1>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.14,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-10 max-w-xl" data-id="element-107" data-mp="woi66ewvqmpw">
            <div className="w-16 h-[2px] bg-[#C5A55A] mb-6" data-id="element-108" data-mp="1aj11y7ibirz8" />
            <p className="text-xl md:text-2xl text-white font-light mb-2" data-id="element-109" data-mp="1fg1447c1ral2">
              We see what a property can become.
            </p>
            <p className="text-sm md:text-base text-gray-300" data-id="element-110" data-mp="11s0u6w2u2f8o">
              Commercial · Residential · Site · Redevelopment
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-10 flex flex-wrap items-center gap-4" data-id="element-111" data-mp="1bjwv0ewb0jgl">
            <a href="#developments" className="inline-flex items-center gap-2 bg-[#C5A55A] hover:bg-[#D4AF37] text-black px-8 py-4 font-medium rounded-sm transition-colors duration-200" data-id="element-112" data-mp="dx6fi88rp2zp">
              See the developments
              <ArrowRight className="w-5 h-5" data-id="element-113" data-mp="247syc2gdp9mc" />
            </a>
            <Link to="/contact" className="inline-flex items-center border border-white/40 hover:border-[#C5A55A] hover:text-[#C5A55A] text-white px-8 py-4 font-medium rounded-sm transition-colors duration-200" data-id="element-114" data-mp="24af53zvg3l3i">
              Bring us an opportunity
            </Link>
          </motion.div>
        </div>
      </div>

      {/* Indicators */}
      <div className="absolute bottom-10 left-6 md:left-10 flex gap-3 z-10" data-id="element-115" data-mp="1xtvgrdu0c3b3">
        {slides.map((slide, index) => <button key={slide.word} onClick={() => setCurrent(index)} className={`h-[3px] transition-all duration-200 ${index === current ? 'bg-[#C5A55A] w-12' : 'bg-white/40 hover:bg-white w-6'}`} aria-label={`Show ${slide.word}`} data-id="element-116" data-mp="21vh1tmgp3nwd" data-mpi={index} />)}
      </div>
    </section>;
}